import { APIResponse } from '../types'
import http from '../api'

const apiPath = import.meta.env.VITE_API_PATH

const configurationController = {
  getBusinessSalesConfigurations: async () => {
    return await http.get<APIResponse<any>>(`${apiPath}business/config/configurations`)
  },
  getAllConfigurations: async () => {
    return await http.get<APIResponse<any>>(`${apiPath}business/config/configurations/with-field-types`)
  },
  updateConfiguration: async (configKey: string, value: any) => {
    return await http.patch<APIResponse<any>>(`${apiPath}business/config/configurations/${configKey}`, {
      value,
    })
  },
}

export default configurationController
